import { workSheetConstants } from '../../_constants';

const initialState = { getWeakAreaLoading: true, data: '', error: false };

export function getWeakAreaReducer(state = initialState, action) {
    switch (action.type) {
        case workSheetConstants.REQUEST_WEAK_AREA:
            return {
                getWeakAreaLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_WEAK_AREA:
            return {
                getWeakAreaLoading: false,
                data: action.getWeakArea,
                error: false
            };
        case workSheetConstants.WEAK_AREA_ERROR:
            return {
                getWeakAreaLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getWeakArea.reducer.js